
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';



const CatHeadTitle = styled.div`
  display: flex;
  flex-direction: column;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 360px;
  text-align: left;
  color: inherit;

  h2 {
    margin-left: 10%;
    color: inherit;
    font-family: "aktiv-grotesk";
    font-size: 108px;
    letter-spacing: 2.4px;
    line-height: 139px;
    margin-top: 7%;
  }
  h3 {
    margin-left: 10%;
    color: inherit;
    padding-left: 2rem;
    font-family: "urw-din";
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 0.67px;
    line-height: 38px;
  }

  h2 > span {
    display: inline-block;

    & > span {
      display: block;
      position: relative;
    }
  }

  .text-title {
    top: 2rem;
    z-index: 1;
    text-transform: unset;
  }

  .title-rubrica {
    color: #EE3D49;
  }

  .text-rubrica {
    text-align: left;
    color: #ffffff;
    font-family: "urw-din";
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.48px;
    line-height: 12px;
  }

  .color-bar {
    height: 30px;
    top: -1rem;
    left: 1rem;
    width: 105%;
  }

  .text-rubrica {
    display: none;
  }

  @media only screen and (max-width: 780px) {
    h2, h3 {
      margin-left: 5%;
    }
    h2 {
      font-size: 52px;
      letter-spacing: -0.74px;
      line-height: 37px;
      margin-top: 12%;
    }
    h3 {
      font-size: 18px;
      letter-spacing: 0.34px;
      line-height: 22px;
      margin-top: 5%;
    }
    .text-title {
      text-transform: uppercase;
    }
    .long-title {
      font-size: 2.5rem;
    }
    .color-bar {
      height: 25px;
      top: 1.5rem;
    }
    .text-subtitle {
      h3 {
        padding-left: 0;
      }
      margin-top: 5%;
    }
    .text-rubrica {
      display: block;
    }
  }

  @media only screen and (max-width: 780px) and (min-width: 640px) {
    h2 {
      font-size: 80px;
      letter-spacing: -0.74px;
      line-height: 37px;
      margin-top: 15%;
    }
    h3 {
      font-size: 28px;
      letter-spacing: 0.34px;
      line-height: 22px;
      margin-top: 5%;
    }
  }
  @media only screen and (max-width: 640px) {
    h2 {
      margin-top: 18%;
    }
    .color-bar {
      height: 20px;
      top: 1rem;
    }
  }
  .text-title.long-title.title-rubrica {

    @media only screen and (max-width: 370px) {
      // line-height: 85px;
      font-size: 2rem;
      // letter-spacing: 2px;
    }

    @media only screen and (min-width: 780px) and (max-width: 1024px) {
      line-height: 60px;
      font-size: 80px;
      letter-spacing: 2px;
    }

    @media only screen and (min-width: 1024px) {
      line-height: 85px;
      // font-size: 80px;
      // letter-spacing: 2px;
    }
  }
`

function NewmagCategoryHeadTitleWidget({
    title,
    title_color,
    subtitle,
    image,
}) {
  const thisComponentRef = useRef();
  const [ElsBase, setElsBase] = useState({});
  const [bgImage, setBgImage] = useState('');
  const [isRubrica, setIsRubrica] = useState(false);
  const [isLongTitle, setIsLongTitle] = useState(false)
  const arRubriche = ["unstoppablewomen"]

  useEffect(
    () => {
      let ar = [
        "tech",
        "economy",
        "education",
        "lifestyle",
        "startup",
        "impact",
      ];

      let menupath = window.location.pathname.replace(/\//g,"");

      setIsRubrica(arRubriche.includes(menupath));
      setIsLongTitle((menupath || '').length >= 15);
      if (image) {
        setBgImage(image);
        console.log('image', image);
      } else if ([...ar, ...arRubriche].includes(menupath)) {
        setBgImage(`/img/${menupath}.jpg`);
        console.log("menupath", menupath);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(
    () => {
      window.addEventListener('scroll', handleScroll);
      try {
        let bottom_element = thisComponentRef.current.querySelector('h3');
        let upper_element = thisComponentRef.current.querySelector('.text-title');
        // console.log(
        //   (!ElsBase.fontSize && bottom_element !== null && upper_element !== null),
        //   ElsBase, 'useEffect', ElsBase.fontSize);
        if (!ElsBase.fontSize && bottom_element !== null && upper_element !== null){
          let data = {
            'bottomEl': bottom_element.getBoundingClientRect(),
            'upperEl': upper_element.getBoundingClientRect(),
            'fontSize': window.getComputedStyle(upper_element, null).getPropertyValue('font-size'),
          };
          // debugger;
          // console.log('setting', data);
          setElsBase(data);
        }
      } catch (error) {
        console.error(error);
      }
      return () => {
        window.removeEventListener('scroll', handleScroll);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );


  function handleScroll() {
    let bottom_element = thisComponentRef.current.querySelector('h3');
    let upper_element = thisComponentRef.current.querySelector('.text-title');
    // console.log(
    //   (!ElsBase.fontSize && bottom_element !== null && upper_element !== null),
    //   ElsBase);
    if (!ElsBase.fontSize && bottom_element !== null && upper_element !== null) {
      let data = {
        'bottomEl': bottom_element.getBoundingClientRect(),
        'upperEl': upper_element.getBoundingClientRect(),
        'fontSize': window.getComputedStyle(upper_element, null).getPropertyValue('font-size'),
      };
      // debugger;
      // console.log('setting', data);
      setElsBase(data, respondeToScroll);
    }
  }

  function respondeToScroll() {
    // let bottom_element = thisComponentRef.current.querySelector('h3');
    // let upper_element = thisComponentRef.current.querySelector('.text-title');

    // let upper_limit = Math.round(upper_element.getBoundingClientRect().y + window.pageYOffset);
    // let bottom_limit = Math.round(bottom_element.getBoundingClientRect().bottom + window.pageYOffset);
    // console.log(ElsBase, upper_limit, bottom_limit, window.pageYOffset);
  }

  return (
    <CatHeadTitle
      style={{ backgroundImage: `url(${image ? image : bgImage})` }}
      ref={thisComponentRef}
    >
      <div>
        <h2>
          <span>
            {isRubrica && <span className="text-rubrica">RUBRICA</span>}
            <span className={`text-title ${isLongTitle ? 'long-title' : '' } ${isRubrica ? 'title-rubrica' : ''}`}>
              {title}
            </span>
            <span
              className="color-bar"
              style={{
                backgroundColor: !isRubrica ? title_color : "transparent",
              }}
            ></span>
          </span>
        </h2>
      </div>
      <div className="text-subtitle">
        <h3>{!isRubrica && <span>{subtitle}</span>}</h3>
        <h3>
          {isRubrica && subtitle && (
            <span>{subtitle}</span>
          )}
        </h3>
      </div>
    </CatHeadTitle>
  )
}

export { NewmagCategoryHeadTitleWidget };

